import { z } from 'zod';
import { UserRole, UserStatus, VehicleType } from './enums.js';
export const UserBaseSchema = z.object({
    id: z.string().uuid(),
    email: z.string().email(),
    phone: z.string().min(8).max(20),
    fullName: z.string().min(2).max(100),
    role: z.nativeEnum(UserRole),
    status: z.nativeEnum(UserStatus),
    avatarUrl: z.string().url().optional(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
export const ClientSchema = UserBaseSchema.extend({
    role: z.literal(UserRole.CLIENT),
    defaultPickupLat: z.number().optional(),
    defaultPickupLng: z.number().optional(),
    defaultPickupAddress: z.string().optional(),
});
export const AgentSchema = UserBaseSchema.extend({
    role: z.literal(UserRole.AGENT),
    vehicleType: z.nativeEnum(VehicleType),
    vehiclePlate: z.string().optional(),
    vehicleColor: z.string().optional(),
    licenseNumber: z.string().optional(),
    licenseExpiry: z.string().datetime().optional(),
    idDocumentUrl: z.string().url().optional(),
    isAvailable: z.boolean().default(false),
    currentLat: z.number().optional(),
    currentLng: z.number().optional(),
    lastLocationUpdate: z.string().datetime().optional(),
    rating: z.number().min(0).max(5).default(0),
    totalRides: z.number().int().default(0),
    acceptanceRate: z.number().min(0).max(100).default(100),
    trainingCompleted: z.boolean().default(false),
    trainingCompletedAt: z.string().datetime().optional(),
});
export const AdminSchema = UserBaseSchema.extend({
    role: z.literal(UserRole.ADMIN),
    permissions: z.array(z.string()).default([]),
});
export const RegisterClientSchema = z.object({
    email: z.string().email(),
    phone: z.string().min(8).max(20),
    fullName: z.string().min(2).max(100),
    password: z.string().min(8).max(100),
    defaultPickupLat: z.number().optional(),
    defaultPickupLng: z.number().optional(),
    defaultPickupAddress: z.string().optional(),
});
export const RegisterAgentSchema = z.object({
    email: z.string().email(),
    phone: z.string().min(8).max(20),
    fullName: z.string().min(2).max(100),
    password: z.string().min(8).max(100),
    vehicleType: z.nativeEnum(VehicleType),
    vehiclePlate: z.string().optional(),
    vehicleColor: z.string().optional(),
    licenseNumber: z.string().optional(),
    licenseExpiry: z.string().datetime().optional(),
    idDocumentUrl: z.string().url().optional(),
});
export const LoginSchema = z.object({
    email: z.string().email(),
    password: z.string().min(1),
});
export const UpdateLocationSchema = z.object({
    lat: z.number().min(-90).max(90),
    lng: z.number().min(-180).max(180),
});
export const UpdateAvailabilitySchema = z.object({
    isAvailable: z.boolean(),
});
export const UpdateProfileSchema = z.object({
    fullName: z.string().min(2).max(100).optional(),
    avatarUrl: z.string().url().optional(),
    vehicleType: z.nativeEnum(VehicleType).optional(),
    vehiclePlate: z.string().optional(),
    vehicleColor: z.string().optional(),
    idDocumentUrl: z.string().url().optional(),
    licenseNumber: z.string().optional(),
    licenseExpiry: z.string().datetime().optional(),
});
